import BaseAddon from './baseAddon' // 基类
import WxAddon from './wxAddon' // 微信
import WxMiniAddon from './wxMiniAddon' // 小程序

class Addon {
  constructor() {
    const ua = window.navigator.userAgent.toLowerCase()
    const matchMini = ua.match(/miniprogram/i)
    const matchWx = ua.match(/MicroMessenger/i)
    if (matchMini && matchMini.toString() === 'miniprogram') {
      // 微信小程序 (微信7.0.0以上版本才有此判断)
      this.currentAddon = new WxMiniAddon()
    } else if (matchWx && matchWx.toString() === 'micromessenger') {
      // 微信浏览器
      if (window.__wxjs_environment === 'miniprogram' || (typeof (global.browserQuery) !== 'undefined' && typeof (global.browserQuery.webSource) !== 'undefined' && global.browserQuery.webSource === 'wechatLite')) {
        console.log('webSource', global.browserQuery.webSource)
        // 大部分手机可采用此判断，是否是小程序，但有小部分华为等手机因为加载慢，这里会出现误判
        this.currentAddon = new WxMiniAddon()
      } else {
        this.currentAddon = new WxAddon()
      }
    } else {
      // 其他处理（web和第三方渠道进入）
      this.currentAddon = new BaseAddon()
    }
  }
  // 处理主入口
  handleRouterBeforeEach(to, from, next, store) {
    this.currentAddon.handleRouterBeforeEach(to, from, next, store)
  }
  /***
   * 页面加载完成
   * @param that
     */
  pageReady(that) {
    this.currentAddon.pageReady(that)
  }
  initBindShareMessage() {
    this.currentAddon.initBindShareMessage()
  }
  /**
 * 调用微信支付
 */
  // initBindWXPay() {
  //   this.currentAddon.initBindWXPay()
  // }
  /**
   * 获取用户信息集 (页面打开时候获取用户信息)
   * obj : {isRefresh: true} // 是否需要刷新
   */
  getInitUserInfo(that, obj) {
    return this.currentAddon.getInitUserInfo(that, obj)
  }
}


export let addon = new Addon()



// WEBPACK FOOTER //
// ./src/utils/tools/addon/index.js